// app/[locale]/our-products/OurProductsClient.tsx
"use client";

import Hero from "@/app/components/thailand-premium-tapioca-starch-products/Hero";
import FooterContact from "@/app/components/FooterContact";
import PoonPhol from "@/app/components/thailand-premium-tapioca-starch-products/PoonPhol";
import { Box } from "@mui/material";
import FoodGrade from "@/app/components/thailand-premium-tapioca-starch-products/FoodGrade";
import IndustrialGrade from "@/app/components/thailand-premium-tapioca-starch-products/IndustrialGrade";
import Specification from "@/app/components/thailand-premium-tapioca-starch-products/Specification";
import TapiocaPearl from "@/app/components/thailand-premium-tapioca-starch-products/TapiocaPearl";
import TapiocaChips from "@/app/components/thailand-premium-tapioca-starch-products/TapiocaChips";
import OurProducts2 from "@/app/components/thailand-premium-tapioca-starch-products/OurProducts2";

export default function OurProductsClient() {
  return (
    <>
      <Hero />
      <Box sx={{ position: "relative", backgroundColor: "#dde7dc" }}>
        <PoonPhol />
        <FoodGrade />
        <IndustrialGrade />
      </Box>
      <Specification />
      <TapiocaPearl />
      <TapiocaChips />
      
      <OurProducts2 />
      <FooterContact />
    </>
  );
}
